import ElementPlus from "element-plus";
import ru from "element-plus/es/locale/lang/ru";
import "element-plus/dist/index.css";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";

let elementPlusInstalled = false;

export const initElementPlusIcons = (App) => {
  if (elementPlusInstalled) {
    return;
  }

  App.use(ElementPlus, {locale: ru});

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    App.component(key, component);
  }
  elementPlusInstalled = true;
}
